module.exports = __webpack_public_path__ + "static/Onlay lower before-e840614b7d0ae0c0105189d272898226.jpg";